import React from 'react';
import classNames from 'classnames';

const Wrapper = (props) => {
    let inputCol = 10;
    if(props.inputCol) {
        inputCol = props.inputCol;
    }

    return <div className={classNames('form-group', 'row', {'has-danger': props.error})}>
        <label className="col-sm-2 col-form-label"><b>{props.label}</b>
            {props.subLabel && <small className="form-text text-muted">{props.subLabel}</small>}</label>
        <div className={'col-md-'+inputCol}>
            {props.children}
            <div className={classNames('form-control-feedback', 'error-block', {'hidden-xs-up': !props.error})}>
                {props.error}
            </div>
        </div>
    </div>;
};

export default Wrapper;


// WEBPACK FOOTER //
// ./web/src/components/common/form/Wrapper.jsx